// extracted by mini-css-extract-plugin
export default {"cardItem":"WidgetCreator_cardItem__9CIm8","widgetCreator":"WidgetCreator_widgetCreator__qjWSu"};